import { axios } from '@lib/axios';

export const translateText = async (sourceText, targetLanguageCode) => {
  const payload = {
    source_text: sourceText,
    target_language_code: targetLanguageCode,
  };

  const response = await axios.post(`/translation`, payload);
  return response.data;
};
